import { ISiteColors } from "./company-atts";
import {
  keyIntfContacts,
  keyIntfMap,
  keyIntfSetDemRate,
  keyIntfShowDemRate,
  keyIntfActs,
  keyIntfCounters,
  keyIntfDemandsPay,
  keyIntfDemandsFree,
  keyIntfCategories,
  keyIntfShowAndroid,
  keyIntfShowIos,
  keyIntfShowAddressInAccounts,
  keyIntfDemands,
} from "../disabledInterfaces";

// ЕДИНЫЙ КОНФИГ КОМПАНИЙ.
// Всё, что отличает одну компанию от другой, описывается здесь одним объектом.
// Чтобы добавить/изменить компанию — правим только этот файл (и, при желании,
// цвета через ISiteColors). Код (customUserAgent.ts) читает данные отсюда.
export interface ICompanyConfig {
  /** Внутренний идентификатор компании (для читаемости конфига). */
  key: string;
  /** Человекочитаемое название. */
  name: string;
  /**
   * Сегменты URL (первый сегмент пути), ведущие на эту компанию.
   * Пример: https://gkh-info.org/asblk/  ->  сегмент "asblk".
   * Можно указать несколько (алиасы).
   */
  segments: string[];
  /**
   * Custom-User-Agent. Используется как заголовок при запросах к API
   * (по нему бэкенд различает компанию) и как ключ хранилища токенов в localStorage.
   */
  userAgent: string;
  /** Тема оформления. */
  colors: ISiteColors;
  /** Ссылка на приложение в App Store (пусто — блок скрыт). */
  iosLink: string;
  /** Ссылка на приложение в Google Play (пусто — блок скрыт). */
  androidLink: string;
  /** Ссылка на пользовательское соглашение. */
  userAgreementLink: string;
  /**
   * Отключённые интерфейсы для этой компании (ключи из disabledInterfaces.ts).
   * То, что перечислено здесь, будет скрыто/недоступно.
   */
  disabledInterfaces: string[];
}

// Компания, применяемая когда сегмент URL не совпал ни с одной из configs.
export const DEFAULT_COMPANY_KEY = "izba";

export const companies: ICompanyConfig[] = [
  {
    key: "izba",
    name: "ЖКХ-Инфо",
    segments: ["lk"],
    userAgent: "ru.krasabs.izba/0.0.1 (web-lk)",
    iosLink: "https://apps.apple.com/us/app/%D0%B6%D0%BA%D1%85-%D0%B8%D0%BD%D1%84%D0%BE/id1485202261",
    androidLink: "https://play.google.com/store/apps/details?id=ru.krasabs.izba",
    userAgreementLink: "https://izba.kras-abs.ru/agrees/izba.html",
    disabledInterfaces: [
      keyIntfContacts,
      keyIntfMap,
      keyIntfActs,
    ],
    colors: {
      headerColor: "linear-gradient(315deg, #2a2a72 0%, #009ffd 74%)",
      headerShadow: "rgb(37 58 73) 0px 1px 4px",
      headerTextColor: "#fff",
      headerDarkMenu: "#3d4652",
      footerColor: "#3d4652",
      footerLinkColor: "#ffffff",
      footerCopyrightColor: "#949495",
      ComId: 0,
      backTotal: "#3D4652",
      backBtnSubmit: "#8FBA00",
      backBtnTotalByMonth: "#8FBA00",
      backBtnTotalByMonthText: "#fff",
      backBtnPayDebt: "#F7CB45",
      backRoutePanel: "#8FBA00",
      backgroundColor: "#3d4652",
      sideBarText: "#fff",
      searchField: "#ffffff80",
      searchFieldStyle: "header__input",
      cardBackgroundColor: "#4F5968",
      cardColor: "#fff",
      titleColor: "#fff",
      chargeTextColor: "#8FBA00",
    },
  },
  {
    key: "krk",
    name: "КРК",
    segments: ["krklk"],
    userAgent: "ru.krasabs.krk/0.0.1 (web-lk)",
    iosLink: "https://apps.apple.com/us/app/%D0%BA%D1%80%D0%BA/id1527236431",
    androidLink: "https://play.google.com/store/apps/details?id=ru.krasabs.krk",
    userAgreementLink: "https://izba.kras-abs.ru/agrees/krk.html",
    disabledInterfaces: [
      keyIntfContacts,
      keyIntfSetDemRate,
      keyIntfShowDemRate,
      keyIntfActs,
    ],
    colors: {
      headerColor: "rgb(143, 186, 0)",
      headerShadow: "0px 1px 4px #8fba00",
      headerTextColor: "#fff",
      headerDarkMenu: "#3d4652",
      footerColor: "#3d4652",
      footerLinkColor: "#ffffff",
      footerCopyrightColor: "#949495",
      ComId: 34,
      backTotal: "#3D4652",
      backBtnSubmit: "#8FBA00",
      backBtnTotalByMonth: "#8FBA00",
      backBtnTotalByMonthText: "#fff",
      backBtnPayDebt: "#F7CB45",
      backRoutePanel: "#8FBA00",
      backgroundColor: "#3d4652",
      sideBarText: "#fff",
      searchField: "#ffffff80",
      searchFieldStyle: "header__input",
      cardBackgroundColor: "#4F5968",
      cardColor: "#fff",
      titleColor: "#fff",
      chargeTextColor: "#8FBA00",
    },
  },
  {
    key: "asb",
    name: "АСБ",
    segments: ["asblk", "nginxishard"],
    userAgent: "ru.krasabs.asb_web_lk/0.0.1 (web-lk)",
    iosLink: "",
    androidLink: "",
    userAgreementLink: "https://izba.kras-abs.ru/agrees/izba.html",
    disabledInterfaces: [
      keyIntfShowAddressInAccounts,
      keyIntfContacts,
      keyIntfSetDemRate,
      keyIntfShowDemRate,
      keyIntfMap,
      keyIntfCounters,
      keyIntfDemandsPay,
      keyIntfDemandsFree,
      keyIntfCategories,
      keyIntfShowAndroid,
      keyIntfShowIos,
    ],
    colors: {
      headerColor: "#fff",
      headerShadow: "0px 0px 8px 0px #00000033",
      headerTextColor: "#454F5D",
      headerDarkMenu: "#454F5D",
      footerColor: "#F6F7FB",
      footerLinkColor: "#454F5D66",
      footerCopyrightColor: "#454F5D",
      ComId: 56,
      backTotal: "#3D4652",
      backBtnSubmit: "#3AAA35",
      backBtnTotalByMonth: "#3AAA35",
      backBtnTotalByMonthText: "#3AAA35",
      backBtnPayDebt: "#3AAA35",
      backRoutePanel: "#8FBA00",
      backgroundColor: "#F6F7FB",
      sideBarText: "#454F5D66",
      searchField: "#454f5d33",
      searchFieldStyle: "header__input_dark",
      cardBackgroundColor: "#454f5d1a",
      cardColor: "#fff",
      titleColor: "#454F5D",
      chargeTextColor: "#000000",
    },
  },
  {
    key: "oirc",
    name: "ОИРЦ",
    segments: ["oirclk"],
    userAgent: "ru.krasabs.oirc/0.0.1 (web-lk)",
    iosLink: "",
    androidLink: "",
    userAgreementLink: "https://izba.kras-abs.ru/agrees/izba.html",
    disabledInterfaces: [
      keyIntfContacts,
      keyIntfActs,
      keyIntfDemands,
      keyIntfMap,
      keyIntfShowAndroid,
      keyIntfShowIos,
    ],
    colors: {
      headerColor: "#fff",
      headerShadow: "0px 0px 8px 0px #00000033",
      headerTextColor: "#454F5D",
      headerDarkMenu: "#454F5D",
      footerColor: "#F6F7FB",
      footerLinkColor: "#454F5D66",
      footerCopyrightColor: "#454F5D",
      ComId: 0,
      backTotal: "#3D4652",
      backBtnSubmit: "#3AAA35",
      backBtnTotalByMonth: "#fff",
      backBtnTotalByMonthText: "#3AAA35",
      backBtnPayDebt: "#3AAA35",
      backRoutePanel: "#8FBA00",
      backgroundColor: "#F6F7FB",
      sideBarText: "#454F5D66",
      searchField: "#454f5d33",
      searchFieldStyle: "header__input_dark",
      cardBackgroundColor: "#454f5d1a",
      cardColor: "#fff",
      titleColor: "#454F5D",
      chargeTextColor: "#3AAA35",
    },
  },
];

/** Компания по умолчанию (fallback, когда сегмент URL неизвестен). */
export const getDefaultCompany = (): ICompanyConfig =>
  companies.find((c) => c.key === DEFAULT_COMPANY_KEY) || companies[0];

/** Найти компанию по сегменту URL. Если не нашли — компания по умолчанию. */
export const getCompanyBySegment = (segment: string): ICompanyConfig =>
  companies.find((c) => c.segments.indexOf(segment) !== -1) || getDefaultCompany();

/** Найти компанию по её Custom-User-Agent. */
export const getCompanyByUserAgent = (userAgent: string): ICompanyConfig | undefined =>
  companies.find((c) => c.userAgent === userAgent);
